import { TOURNAMENT_CONFIRMATION_REQUEST_TABS } from 'Src/consts/tournament';

const MAP: Record<string, string> = {
  HIGH_LEVEL_TOURNAMENT_AVAILABILITY: 'High-level tournament availability',
  HIGH_LEVEL_TOURNAMENT_AVAILABILITY_REQUEST: 'Student availability requested',
  HIGH_LEVEL_TOURNAMENT_AVAILABILITY_DEADLINE: 'Student availability deadline changed',
  HIGH_LEVEL_TOURNAMENT_AVAILABILITY_REMINDER: 'Student availability reminder',
  HIGH_LEVEL_TOURNAMENT_AVAILABILITY_RESPONSE: 'School saved student availability',
  HIGH_LEVEL_TOURNAMENT_AVAILABILITY_OVERRIDE: 'Student availability changed by union',
  HIGH_LEVEL_TOURNAMENT_AVAILABILITY_CANCELLED: 'Student availability request cancelled',
  SCHOOL_TOURNAMENT_INVITE_CREATED: 'Tournament invitation sent to school',
  SCHOOL_ADDED_TO_TOURNAMENT_WAITING_LIST: 'School added to tournament waiting list',
  SCHOOL_REMOVED_FROM_TOURNAMENT: 'School removed from tournament',
  SCHOOL_REMOVED_FROM_TOURNAMENT_WAITING_LIST: 'School removed from tournament waiting list',
  CONFIRMATION_REQUEST_CREATED: 'Confirmation request sent to school',
  TOURNAMENT_CUSTOM: 'Tournament message (custom)',
  TOURNAMENT_COMMUNICATION: 'Tournament chat message or announcement',
  SCHOOL_ADDED_TO_TOURNAMENT_PARTICIPANT: 'School added to tournament',
  TOURNAMENT_DETAILS_UPDATED: 'Tournament details updated',
  TOURNAMENT_PARTICIPANT_ADDED: 'Participant added (organiser notification)',
  PARTICIPANT_ADDED_TO_TOURNAMENT_WAITING_LIST: 'Participant added to waiting list (organiser notification)',
  TOURNAMENT_PARTICIPANT_REMOVED_FROM_WAITING_LIST: 'Participant removed from waiting list (organiser notification)',
  TOURNAMENT_PARTICIPANT_REMOVED: 'Participant removed (organiser notification)',
  TOURNAMENT_REMINDER_TO_UNION: 'Tournament reminder sent to union',
  TOURNAMENT_REMINDER_TO_SCHOOL: 'Tournament reminder sent to school',
  TOURNAMENT_CONFIRMATION_REQUEST_ACCEPTED: 'Tournament confirmation request accepted',
  TOURNAMENT_CONFIRMATION_REQUEST_REJECTED: 'Tournament confirmation request rejected',
  TOURNAMENT_CONFIRMATION_REQUEST_ACCEPTED_SCHOOL: 'Tournament confirmation request accepted (school)',
  TOURNAMENT_CONFIRMATION_REQUEST_REJECTED_SCHOOL: 'Tournament confirmation request rejected (school)'
};

export function getNotificationTypeLabel(type?: string): string {
  if (!type) return 'Notification';
  return MAP[type] || type;
}

export type NotificationAudience = 'SCHOOL' | 'ORGANISER';

const ORGANISER_TYPES = new Set<string>([
  'HIGH_LEVEL_TOURNAMENT_AVAILABILITY_RESPONSE',
  'TOURNAMENT_PARTICIPANT_ADDED',
  'PARTICIPANT_ADDED_TO_TOURNAMENT_WAITING_LIST',
  'TOURNAMENT_PARTICIPANT_REMOVED'
]);

export function getNotificationAudience(type?: string): NotificationAudience {
  if (!type) return 'SCHOOL';
  return ORGANISER_TYPES.has(type) ? 'ORGANISER' : 'SCHOOL';
}

export function getNotificationAudienceLabel(audience: NotificationAudience): string {
  return audience === 'ORGANISER' ? 'Organiser' : 'School';
}
